import { render, staticRenderFns } from "./ShopOwner.vue?vue&type=template&id=12613550&scoped=true&"
import script from "./ShopOwner.vue?vue&type=script&lang=ts&"
export * from "./ShopOwner.vue?vue&type=script&lang=ts&"
import style0 from "./ShopOwner.vue?vue&type=style&index=0&id=12613550&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12613550",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VContainer,VMain})
